<template>
	<div class="e-float-input !w-14 float items-center -ml-14 h-10" v-bind:class="cssClass">
		<input class="text-center !px-0 !h-full !text-color-5 !bg-color-2 !border-3 !border-color-2" :value="label" readonly tabindex="-1">
	</div>
</template>
<script>
export default {
	name: "TextBoxExtension",
	props: ['label', 'cssClass'],
}
</script>
